<template>
  <v-dialog :value="value" persistent max-width="600">
    <v-card>
      <v-card-title class="headline">Email Queued Successfully</v-card-title>
      <v-card-text style="color: black">
        Your email has been added to the queue and will be sent shortly.
        <br /><br />
        <a @click="viewQueue" style="text-decoration: underline">View Email Queue</a>
      </v-card-text>
      <v-card-actions>
        <template v-if="onStay">
          <v-btn text depressed small @click="closeAndReturn">{{ returnLabel }}</v-btn>
          <div class="flex-grow-1"></div>
          <v-btn text depressed small @click="closeAndStay">{{ stayLabel }}</v-btn>
        </template>
        <template v-else>
          <div class="flex-grow-1"></div>
          <v-btn text depressed small @click="closeAndReturn">Close</v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    onClose: Function,
    onStay: Function,
    returnLabel: {
      type: String,
      default: "Return",
    },
    stayLabel: {
      type: String,
      default: "Send Another Email",
    },
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    closeAndReturn() {
      this.dismiss();
      if (this.onClose) this.onClose();
    },
    closeAndStay() {
      this.dismiss();
      if (this.onStay) this.onStay();
    },
    viewQueue() {
      this.dismiss();
      this.$router.push("/email_queue");
    },
  },
};
</script>
